import { createFileRoute } from '@tanstack/react-router';
import { MessageLogPage } from '@/features/messaging/pages/message-log-page';

export const Route = createFileRoute('/_app/messages/')({ component: MessageLogPage });
